export default "__VITE_ASSET__xlHcqkDu__"